import { ChangeDetectionStrategy, ChangeDetectorRef, Component, effect, inject } from '@angular/core';

import { CadsToastComponent } from '../components/cads-toast/cads-toast.component';

import { CadsGlobalToastService } from './cads-global-toast.service';

/**
 * Single app-level outlet for {@link CadsGlobalToastService}. Mount once at the app root (sibling of
 * {@link CadsGlobalModalHostComponent}) so toasts render above modal scrims.
 */
@Component({
  selector: 'cads-global-toast-host',
  imports: [CadsToastComponent],
  templateUrl: './cads-global-toast-host.component.html',
  styleUrl: './cads-global-toast-host.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CadsGlobalToastHostComponent {
  private readonly _toastService = inject(CadsGlobalToastService);
  private readonly _cdr = inject(ChangeDetectorRef);

  readonly toasts = this._toastService.toasts;

  constructor() {
    this._toastService.registerHost();
    effect(() => {
      this._toastService.toasts();
      this._cdr.markForCheck();
    });
  }
}
